import { collectPaymentsHelpData, tallyHelpData, bankRecoHelpData } from '../../modules/shared/help.constants';

// TODO: Add routerParams functionality
export interface GridTileItemsType {
  callBackActive?: boolean;
  bgClass?: string;
  enumValue?: string;
  iconImage: string;
  itemGroup?: string;
  label: string;
  route?: string;
  navigateNotToRoute?: boolean;
  url?: string;
  comingSoon?: boolean;
  olympus?: boolean;
  showBbps?: boolean;
  helpdata?: any;
  rightlogo?: string;
  brandlogo?: string;
  hideFav?: boolean;
}

export enum GridTileItemsTypeEnum {
  COLLECT_PAYMENTS = 'COLLECT_PAYMENTS',
  OLYMPUS_COLLECT_PAYMENTS = 'OLYMPUS_COLLECT',
  OLYMPUS_BANK_RECONCILIATION = 'BANK_RECONCILIATION',
  TALLY_INTEGRATION = 'TALLY_INTEGRATION',
  SEAMLESS_BANKING = 'SEAMLESS_BANKING',
  BANK_CARDS = 'BANK_CARDS',
  COLLECT_VIEW_TRANSACTION = 'COLLECT_VIEW_TRANSACTION',
  COLLECT_VIEW_SETTLEMENT = 'COLLECT_VIEW_SETTLEMENT',
  COLLECT_PAYMENT_LINK = 'COLLECT_PAYMENT_LINK',
  COLLECT_MANAGE_CUSTOMER = 'COLLECT_MANAGE_CUSTOMER',
  COLLECT_MANAGE_INVOICE = 'COLLECT_MANAGE_INVOICE',
  COLLECT_REMINDER_CONFIGURATION = 'COLLECT_REMINDER_CONFIGURATION',
  VOCUHER = 'VOCUHER',
  COLLECT_PAYMENT_GATEWAY = 'COLLECT_PAYMENT_GATEWAY',
  COLLECT_RECEIPT = 'COLLECT_RECEIPT'
}

const manageBranchesItem: GridTileItemsType = {
  iconImage: './../../assets/svg/manage-branches.svg',
  label: 'Manage Branches',
  route: '/manage/branches'
};

const manageUsersItem: GridTileItemsType = {
  iconImage: './../../assets/svg/manageusers.svg',
  label: 'Manage Users',
  route: '/manage/users'
};

const manageProfileItem: GridTileItemsType = {
  iconImage: './../../assets/svg/myprofile.svg',
  label: 'My Profile',
  route: '/profile'
};

const manageVendorsItem: GridTileItemsType = {
  iconImage: './../../assets/svg/managevendors.svg',
  label: 'Manage Vendors',
  route: '/manage/vendors'
};

const manageEnterprisesItem: GridTileItemsType = {
  iconImage: './../../assets/svg/myprofile.svg',
  label: 'Manage Enterprises',
  route: '/manage/vendors'
};

const manageBillersItem: GridTileItemsType = {
  iconImage: './../../assets/svg/managebillers.svg',
  label: 'Manage Billers',
  route: '/manage/billers'
};

const manageOwnersItem: GridTileItemsType = {
  iconImage: './../../assets/svg/manage-owner/rentals-owners.svg',
  label: 'Manage Owners',
  route: '/manage/owners'
};

const backOfficeItem: GridTileItemsType = {
  iconImage: './../../assets/svg/myprofile.svg',
  label: 'Back Office',
  route: '/backoffice'
};

const approveRequest: GridTileItemsType = {
  iconImage: 'assets/svg/myprofile.svg',
  label: 'Approve Request',
  route: '/approve-request'
};

export const vendorPaymentsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VENDOR_PAYMENTS',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Invoice Management',
  route: '/pay/invoices'
};

export const utilityPaymentsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  rightlogo: './../../assets/svg/bbps-right-logo.svg',
  brandlogo: './../../assets/images/axis_logo.jpg',
  enumValue: 'UTILITY_PAYMENTS',
  iconImage: './../../assets/svg/utilitypayments.svg',
  label: 'Bill Payment',
  route: '/pay/utility-payments',
  showBbps: true
};

export const gstPaymentsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'GST_PAYMENTS',
  iconImage: './../../assets/svg/managegstpayments.svg',
  label: 'GST Payment',
  route: '/pay/managegstpayments'
};

export const platformDebitCardItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PLATFORM_DEBIT_CARD',
  // hideFav: true,
  iconImage: './../../assets/svg/platform-debit-card.svg',
  label: 'Platform Debit Card',
  route: '/platform-debit-card'
};

export const rentalPaymentsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'RENTAL_PAYMENTS',
  iconImage: './../../assets/svg/rental-payments/rental-payment.svg',
  label: 'Rental Payment',
  route: '/rental-payment'
};

export const cardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_CARDS',
  iconImage: './../../assets/svg/cards.svg',
  itemGroup: 'Cards',
  label: 'Cards'
};

export const getCardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_CARDS',
  iconImage: './../../assets/svg/cards.svg',
  itemGroup: 'Cards',
  label: 'Get Cards',
  navigateNotToRoute: true
};

export const viewRelationshipsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_RELATIONSHIPS',
  iconImage: './../../assets/svg/view-relationships-icon.svg',
  itemGroup: 'Cards',
  label: 'Card Relationships',
};

export const viewCardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_CARDS',
  iconImage: './../../assets/svg/cards.svg',
  itemGroup: 'Cards',
  label: 'My Cards'
};

export const viewTransactionsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_TRANSACTIONS',
  iconImage: './../../assets/svg/txns.svg',
  itemGroup: 'Cards',
  label: 'Statement'
};

export const viewStatementsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_STATEMENTS',
  iconImage: './../../assets/svg/statements.svg',
  itemGroup: 'Cards',
  label: 'Card Statements'
};

export const cardPerformanceItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CARD_PERFORMANCE',
  iconImage: './../../assets/svg/card-performance.svg',
  label: 'Card Performance',
  route: '/card-performance'
};

export const programStats: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PROGRAM_STATS',
  iconImage: 'assets/svg/account-stats.svg',
  itemGroup: 'Cards',
  label: 'Card Program Stats',
};

export const accountDetailsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VIEW_ACCOUNT_DETAILS',
  iconImage: './../../assets/svg/accounts.svg',
  itemGroup: 'Cards',
  label: 'Card Accounts',
};

export const freedomRewardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'FREEDOM_REWARDS_ACCOUNT',
  iconImage: './../../assets/svg/freedom-reward.svg',
  itemGroup: 'Cards',
  label: 'Freedom Rewards',
};



export const mealCardAccoutViewAccount: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'MEAL_VIEW_ACCOUNT_DETAILS',
  iconImage: 'assets/svg/accounts.svg',
  itemGroup: 'Meal Card',
  label: 'View Account',
};


export const mealCardTransactionItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'MEAL_VIEW_TRANSACTIONS',
  iconImage: 'assets/svg/txns.svg',
  itemGroup: 'Meal Card',
  label: 'All Transactions'
};


export const mealViewCardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'MEAL_VIEW_CARDS',
  iconImage: 'assets/svg/cards.svg',
  itemGroup: 'Meal Card',
  label: 'Manage Cards'
};


// EMPLOYEE REWARDS
// Redeem Points,
// Balances,
// Statement (Transactions),
// My Orders
export const employeeRewardItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EMPLOYEE_REWARD',
  iconImage: './../../assets/home/rewards-incentives.svg',
  route: '/marketplace/dashboard',
  label: 'Redeem Points',
};

export const employeeRewardAccountItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EMPLOYEE_REWARD_ACCOUNT',
  iconImage: './../../assets/svg/view-reward-account-icon.svg',
  route: '/cards/dashboard-cards',
  itemGroup: 'Employee Rewards',
  label: 'Balances',
};

export const employeeRewardTransactionItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EMPLOYEE_REWARD_TRANSACTION',
  iconImage: './../../assets/home/transactions.svg',
  route: '/cards/dashboard-cards',
  itemGroup: 'Employee Rewards',
  label: 'Statements',
};

export const employeeOrderItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EMPLOYEE_REWARD_ORDERS',
  iconImage: './../../assets/home/rewards-incentives.svg',
  route: '/marketplace/orders',
  label: 'My Orders',
};

// CHANNEL INCENTIVES
// Redeem Points,
// Balances,
// Statement (Transactions),
// My Orders

export const channelIncentiveItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CHANNEL_INCENTIVE',
  iconImage: './../../assets/home/rewards-incentives.svg',
  route: '/marketplace/dashboard',
  label: 'Redeem Points',
};

export const channelIncentiveAccountItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CHANNEL_INCENTIVE_ACCOUNT',
  iconImage: './../../assets/svg/view-reward-account-icon.svg',
  route: '/cards/dashboard-cards',
  itemGroup: 'Channel Incentives',
  label: 'Balances',
};

export const channelIncentiveTransactionItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CHANNEL_INCENTIVE_TRANSACTION',
  iconImage: './../../assets/home/transactions.svg',
  itemGroup: 'Channel Incentives',
  route: '/cards/dashboard-cards',
  label: 'Statements',
};

export const channelIncentiveOrdersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CHANNEL_INCENTIVE_ORDERS',
  iconImage: './../../assets/home/transactions.svg',
  itemGroup: 'Channel Incentives',
  route: '/marketplace/orders',
  label: 'My Orders',
};

export const channelIncentiveProgramItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'CHANNEL_INCENTIVE_PROGRAM',
  iconImage: './../../assets/home/rewards-incentives.svg',
  itemGroup: 'Channel Incentives',
  route: '/channel-incentive-program',
  label: 'Channel Incentive Program',
};

export const rewardsAndOffersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'REWARDS_AND_OFFERS',
  iconImage: './../../assets/svg/reward.svg',
  label: 'Partnered Services',
  route: '/reward'
};

export const expenseManagemetItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EXPENSE_MANAGEMENT',
  iconImage: './../../assets/svg/expenseManagement.svg',
  label: 'All Expenses',
  route: '/expense-management'
};

export const pettyCashManagementItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PETTY_CASH',
  iconImage: './../../assets/petty-cash-home.svg',
  label: 'Petty Cash',
  route: '/pettyCash/admin?program=petty_cash'
};

export const imprestPaymentsManagementItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'IMPREST_PAYMENTS',
  iconImage: './../../assets/petty-cash-home.svg',
  label: 'Imprest Payments',
  route: '/imprestPayments/admin-v2',
};

export const employeeBenefitsManagementItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EMPLOYEE_BENEFITS',
  iconImage: './../../assets/svg/employee-benefits-section-icon.svg',
  label: 'Employee Benefits',
  route: '/employeeBenefits/admin-v2/wallets',
};

export const erupiManagementItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'E_RUPI',
  iconImage: './../../assets/svg/addexpenseManagement.svg',
  label: 'eRupi Vouchers',
};

export const addExpenseManagemetItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'ADD_EXPENSE',
  iconImage: './../../assets/svg/addexpenseManagement.svg',
  label: 'Add Expense',
  route: '/expense-management/add-expense'
};


export const expenseAnalyticsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'EXPENSE_ANALYTICS',
  iconImage: './../../assets/svg/addexpenseManagement.svg',
  label: 'Analytics',
  route: '/expense-management/analytics'
};


export const collectPaymentsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_PAYMENTS,
  iconImage: './../../assets/svg/collect-payment.svg',
  label: 'Collect Payments',
  route: '/collect/invoices'
};


export const voucherProductsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'ALL_VOUCHERS',
  iconImage: './../../assets/svg/collect-payment.svg',
  label: 'All Vouchers',
  route: '/marketplace/dashboard'
};

export const myOrdersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VOUCHER_ORDERS',
  iconImage: './../../assets/svg/collect-payment.svg',
  label: 'Orders',
  route: '/marketplace/orders'
};

export const voucherCartItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'VOUCHER_CART',
  iconImage: './../../assets/svg/collect-payment.svg',
  label: 'Cart',
  route: '/marketplace/cart'
};

export const olympusCollectItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.OLYMPUS_COLLECT_PAYMENTS,
  iconImage: './../../assets/svg/collect-payment.svg',
  label: 'Olympus Collect',
  olympus: true,
  helpdata: collectPaymentsHelpData
};

export const reconciliationItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.OLYMPUS_BANK_RECONCILIATION,
  iconImage: './../../assets/images/bank-reco.inactive.svg',
  label: 'Reconciliation',
  olympus: true,
  helpdata: bankRecoHelpData,
}

export const seamlessBankingItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'SEAMLESS_BANKING',
  iconImage: './../../assets/home/Icon-seamless-banking.svg',
  label: 'Bank Accounts',
  route: '/seamless-banking'
};

export const bankCardsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'BANK_CARDS',
  iconImage: './../../assets/home/bank-card.svg',
  label: 'Bank Cards',
  route: '/bank-cards'
};

export const iciciBankItem: GridTileItemsType = {
  bgClass: 'white-bg',
  rightlogo: './../../assets/home/icici-logo.png',
  iconImage: './../../assets/home/Icon-seamless-banking.svg',
  label: 'Seamless Banking',
  enumValue: 'SEAMLESS_BANKING',
  route: '/seamless-banking',
};

//Tally is renamed to ERP sync
export const tallyItem: GridTileItemsType = {
  bgClass: 'white-bg',
  // rightlogo: './../../assets/home/tally-right.svg',
  iconImage: './../../assets/home/tally-sync.svg',
  label: 'ERP Sync',
  enumValue: GridTileItemsTypeEnum.TALLY_INTEGRATION,
  comingSoon: false,
  helpdata: tallyHelpData
};

export const yesBankItem: GridTileItemsType = {
  bgClass: 'white-bg',
  iconImage: './../../assets/home/yesbank-logo.png',
  label: 'Yes Bank Current Account',
  route: '/home',
  comingSoon: true
};

const partnerDashboardItem: GridTileItemsType = {
  iconImage: './../../assets/svg/manageusers.svg',
  label: 'Partner Dashboard',
  route: '/partner-dashboard'
};


// collections items

export const manageCustomersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_MANAGE_CUSTOMER,
  iconImage: '/assets/svg/collection/collection-mange-customer.svg',
  label: 'Customer Management',
  route: '/collection/manage-customer'
};

export const manageInvoicesItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_MANAGE_INVOICE,
  iconImage: '/assets/svg/collection/collection-manage-invoice.svg',
  label: 'Invoices',
  route: '/collection/manage-invoices'
};

export const receiptsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_RECEIPT,
  iconImage: '/assets/svg/collection/collection-manage-invoice.svg',
  label: 'Receipts',
  route: '/collection/receipts'
};


export const reminderConfigurationItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_REMINDER_CONFIGURATION,
  iconImage: '/assets/svg/collection/collection-reminder-configuration.svg',
  label: 'Reminder',
  route: '/collection/reminder/payment-link'
};

export const transfersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PAYOUT_TRANSFERS',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Transfers',
  route: '/payout/transfers'
};

export const payoutBeneficiaryItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PAYOUT_MANAGE_BENEFICIARY',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Beneficiaries',
  route: '/payout/manage-beneficiaries'
};

export const payoutAccountItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PAYOUT_ACCOUNT',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Statements',
  route: '/payout/payout-account?activeTab=transactions'
};


// Payment gateway items
// orders settlement refunds payment links
export const transactionsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_VIEW_TRANSACTION,
  iconImage: '/assets/svg/collection/collection-transaction.svg',
  label: 'Transactions',
  route: '/payment-gateway?tab=transactions'
};

export const ordersItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PAPG_ORDERS',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Orders',
  route: '/payment-gateway?tab=orders'
};

export const settlementsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_VIEW_SETTLEMENT,
  iconImage: '/assets/svg/collection/collection-settlement.svg',
  label: 'Settlements',
  route: '/payment-gateway?tab=settlements'
};

export const refundsItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: 'PAPG_REFUNDS',
  iconImage: './../../assets/svg/vendor-payment.svg',
  label: 'Refunds',
  route: '/payment-gateway?tab=refunds'
};

export const paymentLinksItem: GridTileItemsType = {
  bgClass: 'white-bg',
  enumValue: GridTileItemsTypeEnum.COLLECT_PAYMENT_LINK,
  iconImage: '/assets/svg/collection/collection-payment-link.svg',
  label: 'Payment Links',
  route: '/collection/quick-collect'
};

/** list of items which can appear inside the Integration section on the home page */
export const integrationItemsList: GridTileItemsType[] = [
  // bankCardsItem,
  // yesBankItem
];

/** list of items which can appear inside the settings section on the home page */
export const settingsItemsList: GridTileItemsType[] = [
  manageProfileItem,
  manageBranchesItem,
  manageUsersItem,
  manageVendorsItem,
  manageEnterprisesItem,
  manageBillersItem,
  manageOwnersItem,
  approveRequest,
  backOfficeItem,
  partnerDashboardItem,
];

// list of items where if disabled user can request a callback from sales team
export const callbackAvailableList: GridTileItemsType[] = [
  olympusCollectItem,
  tallyItem,
  reconciliationItem
]
/** list of items which can appear inside the payable management section on the home page */
export const payableManagementItemsList: GridTileItemsType[] = [
  vendorPaymentsItem,
  utilityPaymentsItem,
  gstPaymentsItem,
  rentalPaymentsItem,
  // collectPaymentsItem,
  // olympusCollectItem,
  seamlessBankingItem,
  // platformDebitCardItem,
  // reconciliationItem,
  // tallyItem,
  // bankCardsItem,
];

/** list of items which can appear inside the payable management section on the home page */
export const payoutManagementItemsList: GridTileItemsType[] = [
  transfersItem,
  payoutAccountItem,
  payoutBeneficiaryItem
];

/** list of items which can appear inside the payment gateway management section on the home page */
export const paymentGatewayItemsList: GridTileItemsType[] = [
  ordersItem,
  transactionsItem,
  refundsItem,
  settlementsItem
  // paymentLinksItem
];

/** list of items which can appear inside the payable management section on the home page */
export const collectionManagementItemsList: GridTileItemsType[] = [
  // transactionsItem,
  // manageCustomersItem,
  manageInvoicesItem,
  reminderConfigurationItem,
  receiptsItem,
  reconciliationItem,
  tallyItem
];

/** list of items which can appear inside the Employee Rewards section on the home page */
export const employeeRewardsItemsList: GridTileItemsType[] = [
  employeeRewardItem,
  employeeRewardAccountItem,
  employeeRewardTransactionItem,
  employeeOrderItem
];

export const mealCardItemsList: GridTileItemsType[] = [
  mealCardAccoutViewAccount,
  mealViewCardsItem,
  mealCardTransactionItem,
]

/** list of items which can appear inside the Channel Incentives section on the home page */
export const channelIncentiveItemsList: GridTileItemsType[] = [
  channelIncentiveItem,
  channelIncentiveAccountItem,
  channelIncentiveTransactionItem,
  channelIncentiveOrdersItem,
  channelIncentiveProgramItem
];

/** list of items which can appear inside the cards section on the home page for enterprise admin or enkash user */
export const cardsDashboardItemsList: GridTileItemsType[] = [
  // viewRelationshipsItem,
  // accountDetailsItem,
  viewCardsItem,
  viewTransactionsItem,
  employeeBenefitsManagementItem,
  // viewStatementsItem,
  // programStats,
  // cardPerformanceItem,
  // freedomRewardsItem
];


export const voucherItemsList: GridTileItemsType[] = [
  voucherProductsItem,
  myOrdersItem,
  voucherCartItem
];


/** list of items which can appear inside the cards section on the home page for employee user */
export const employeeViewCardsItemsList: GridTileItemsType[] = [
  viewCardsItem,
  viewTransactionsItem,
  employeeBenefitsManagementItem,
];

/** list of items which can appear inside the cards section on the home page
 * when card is not issued or user has not yet applied for enkash card */
export const defaultCardsItemsList: GridTileItemsType[] = [getCardsItem];

/** list of items which can appear inside the More section on the home page */
export const expenseItemsList: GridTileItemsType[] = [
  expenseAnalyticsItem,
  pettyCashManagementItem,
  imprestPaymentsManagementItem,
  // erupiManagementItem,
  addExpenseManagemetItem,
  expenseManagemetItem
];

export const moreItemsListPettyCash: GridTileItemsType[] = [
  pettyCashManagementItem
];

export const moreItemsListErupi: GridTileItemsType[] = [
  erupiManagementItem
];

export const viewDocsLinks = {
  payment_gateway: 'https://docs.enkash.com/payment-gateway',
  payout: 'https://docs.enkash.com/payouts',
  payables: 'https://docs.enkash.com/account-payables',
  collections: 'https://docs.enkash.com/account-receivables',
  channel_incentives: 'https://docs.enkash.com/loyalty',
  vouchers: 'https://docs.enkash.com/loyalty',
  expense_management: 'https://docs.enkash.com/expense-management',
  cards: 'https://docs.enkash.com/corporate-cards',
  employee_rewards: 'https://docs.enkash.com/loyalty',
  verification_suits: 'https://docs.enkash.com/verification-suite',
}

export const landingPageMap = {
  payment_gateway: '/payment-gateway?tab=orders',
  payout: '/payout/transfers',
  payables: '/pay/analytics',
  collections: '/collection/dashboard',
  channel_incentives: '/marketplace/dashboard?program=channel_incentive',
  vouchers: '/marketplace/dashboard',
  expense_management: '/expense-management',
  cards: '/cards/dashboard-cards',
  employee_rewards: '/marketplace/dashboard?program=employee_rewards',
  verification_suits: '',
  partner_dashboard: 'collection/partner/dashboard'
}


export enum PRODUCTID_ENUM {
  PAYMENT_GATEWAY = 'payment_gateway',
  PAYOUT = 'payout',
  ACCOUNT_PAYABLE = 'payables',
  ACCOUNT_RECEIVABLE = 'collections',
  CHANNEL_INCENTIVE = 'channel_incentives',
  VOUCHER = 'vouchers',
  EXPENSE_MANAGEMENT = 'expense_management',
  CORPORATE_CARD = 'cards',
  EMPLOYEE_REWARD = 'employee_rewards',
  VERIFICATION_SUITS = 'verification_suits'
}
